/**
 * Layout Registry
 */

import type { LayoutEntry } from './core';

export const LAYOUT_REGISTRY = [
  { id: 'cards', label: 'Cards', icon: '\u25A6' },
  { id: 'table', label: 'Table', icon: '\u25A4' },
  { id: 'list', label: 'List', icon: '\u2630' },
  { id: 'kanban', label: 'Kanban', icon: '\u25A5' },
  { id: 'calendar', label: 'Calendar', icon: '\uD83D\uDCC5' },
  { id: 'mail', label: 'Mail', icon: '\u2709' },
] as const satisfies readonly LayoutEntry[];

export type LayoutId = (typeof LAYOUT_REGISTRY)[number]['id'];

export function getLayoutEntry(id: LayoutId | (string & {})): LayoutEntry | undefined {
  return (LAYOUT_REGISTRY as readonly LayoutEntry[]).find((e) => e.id === id);
}
